export default {
    XML_PATH_MANAGE_STOCK: 'cataloginventory/item_options/manage_stock',
    XML_PATH_BACKORDERS: 'cataloginventory/item_options/backorders',
    XML_PATH_MAX_SALE_QTY: 'cataloginventory/item_options/max_sale_qty',
    XML_PATH_MIN_SALE_QTY: 'cataloginventory/item_options/min_sale_qty',
    XML_PATH_MIN_QTY: 'cataloginventory/item_options/min_qty',
    XML_PATH_ENABLE_QTY_INCREMENTS: 'cataloginventory/item_options/enable_qty_increments',
    XML_PATH_QTY_INCREMENTS: 'cataloginventory/item_options/qty_increments',
    XML_PATH_CAN_SUBTRACT: 'cataloginventory/options/can_subtract',
    XML_PATH_CAN_BACK_IN_STOCK: 'cataloginventory/options/can_back_in_stock'
}



// WEBPACK FOOTER //
// ./src/view/constant/catalog/stock/ConfigConstant.js